const AboutUsSection = () => (
  <section id="about" className="py-16 bg-white">
    <div className="container mx-auto px-4">
      <h2 className="text-3xl md:text-4xl font-bold text-primary text-center mb-12">
        Get to know us better
      </h2>
      <div className="max-w-4xl mx-auto">
        <p className="text-xl mb-6 text-center">
          At Mobile Detail Co. we truly care about the job we do and our top priority is to provide our customers the best service possible!
        </p>
        <p className="text-gray-700 mb-8">
          We have over 10 years experience in the car wash and automotive detailing industry. Our mission is to save you time and deliver exceptional results. We offer an experience and level of detail that you and your car won't forget. Our friendly and professionally trained staff have been screened for your protection and have been cleaning, detailing, and protecting cars with only the highest quality of service.
        </p>
        <p className="text-gray-700 mb-8">
          We also offer a complete line of mobile services for your car. If you wish for us to come to your location please contact us for pricing, we will give you a free estimate and will work within your budget needs. We will be more than happy to schedule a time and location that is convenient for you. We serve the Minneapolis and St. Paul metropolitan area and surrounding cities.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="flex flex-col items-center text-center">
            <div className="text-primary font-bold text-xl mb-2">10+</div>
            <div className="text-gray-600">Years Experience</div>
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="text-primary font-bold text-xl mb-2">1000+</div>
            <div className="text-gray-600">Vehicles Detailed</div>
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="text-primary font-bold text-xl mb-2">500+</div>
            <div className="text-gray-600">Happy Clients</div>
          </div>
          <div className="flex flex-col items-center text-center">
            <div className="text-primary font-bold text-xl mb-2">20+</div>
            <div className="text-gray-600">Service Options</div>
          </div>
        </div>
      </div>
      {/* Key Features */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
        <div className="text-center p-6 rounded-lg bg-primary-dark text-white shadow-lg">
          <h3 className="text-xl font-bold mb-4">Over 10 Years Experience</h3>
          <p>Industry expertise and proven results for your vehicle</p>
        </div>
        <div className="text-center p-6 rounded-lg bg-primary-dark text-white shadow-lg">
          <h3 className="text-xl font-bold mb-4">Top Provider in Minnesota</h3>
          <p>Trusted by customers throughout the Twin Cities</p>
        </div>
        <div className="text-center p-6 rounded-lg bg-primary-dark text-white shadow-lg">
          <h3 className="text-xl font-bold mb-4">We Deliver Quality</h3>
          <p>Premium service with attention to every detail</p>
        </div>
        <div className="text-center p-6 rounded-lg bg-primary-dark text-white shadow-lg">
          <h3 className="text-xl font-bold mb-4">Award Winning Service</h3>
          <p>Recognized for our commitment to excellence</p>
        </div>
      </div>
    </div>
  </section>
);

export default AboutUsSection; 